import React, { Component, Fragment } from "react";
import _ from 'lodash';
import {
  Button,
  DialogActions,
  DialogContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Input,
  FormHelperText,
  Grid,
  Checkbox,
  FormControlLabel
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { AutoCompleteInput } from "components/Global/FormikMaterial";
import { compose } from "redux";
import { withFormik } from "formik";
import Modal from "components/Modal";
import { connect } from "react-redux";
import { getContact, updateContact, getContacts } from "store/state/contacts";
import { getCompanyTypeById } from "store/state/companies";
import { fetchRoles } from "store/state/roles";
import { isEmpty } from "lodash";
import TextField from "components/Global/Fields/Text";
import inputComponentMask from "lib/inputMask";
import { states } from "constants/states";
import companyTypeIDs from "constants/companyTypes";

const styles = () => ({
  checkboxLabelRoot: {
    marginTop: '30px',
    marginLeft: '20px',
    
  },
  checkboxRoot: {    
    marginLeft: '10px',
    height: '32px'
  },
});


class ContactEdit extends Component {
  state = {};

  componentDidMount() {
    this.props.fetchRoles();
  }
  
  componentDidUpdate(prevProps) {
    const {contactId} = this.props;
    const {contactId: prevContactId} = prevProps;
    if (contactId && contactId != prevContactId) {
      this.props.getContact({ id: contactId });
    }
    
    const companyId = this.props?.contact?.contact?.companyId;
    const prevCompanyId = prevProps.contact?.contact?.companyId;
    if (companyId && companyId !== prevCompanyId) {
      this.props.getCompanyTypeById({ companyId: companyId });
    }
  }

  addUpdateRole = selectedRole => {
    if (!this.props.values.user) {

      const newUser = {
        email: this.props.values.email,
        roles: [{ role: selectedRole }]
      };
      this.props.values.user = newUser;
    }

    this.props.values.user.roles[0].role = selectedRole;
    this.setState(this.state);
    this.props.setFieldValue();
  };

  handleSubmit = () => {
    const valuesToSubmit = { ...this.props.values };
    if (typeof valuesToSubmit.phone === "string") {
      valuesToSubmit.phone = Number(
        valuesToSubmit.phone.replace(/[^0-9.]+/g, "")
      );
    }

    const keysToNormalize = ["phone", "address", "address2", "city", "state", "zip"];

    Object.keys(valuesToSubmit).forEach((key) => {
      if (keysToNormalize.includes(key)) {
        const value = valuesToSubmit[key];
        valuesToSubmit[key] = value ? value : null;
      }
    });
    this.props.updateContact(valuesToSubmit);
    this.props.handleClose();
  };

  isProTier = () =>{
    if(this.props.authentication){
        return this.props.authentication.companyLevel==="Professional"
        || this.props.authentication.companyLevel==="Enterprise"
        || this.props.authentication.companyLevel==="Secondary Sponsor"
    }else{
      return false;
    }
  }
  
  userBelongsToBrokerCompany = () => {
    if (this.props?.companyTypes?.length < 1) {
      return false;
    }
    return this.props.companyTypes.map(companyType => {
      return companyType.id;
    }).includes(companyTypeIDs.BROKER);
  };

  renderReportDesignerButton = () =>{
    const {values} = this.props;
    if(this.isProTier()){
      return(
      <FormControlLabel 
                    label="Report Designer"
                    labelPlacement="end"
                    classes={{root: this.props.classes.checkboxLabelRoot}}
                    control={
                        <Checkbox
                          name={"isReportDesigner"}
                          classes={{root: this.props.classes.checkboxRoot}}
                          checked={values.isReportDesigner} 
                          onChange={({ target: { checked  } }) => {
                          this.props.setFieldValue("isReportDesigner", checked );
                          }}
                          value={values.isReportDesigner}/>
                      }  />);
    }else{
      return null
    }
  }

  renderNotifyUserCheckbox = () => {
    const { values } = this.props;
    const isDisabled = !values.user?.roles.length;

    return (
      <FormControlLabel
        label="Notify user"
        labelPlacement="end"
        classes={{ root: this.props.classes.checkboxLabelRoot }}
        control={
          <Checkbox
            name={"isNotifyUser"}
            classes={{ root: this.props.classes.checkboxRoot }}
            checked={values.isNotifyUser}
            onChange={({ target: { checked } }) => {
              this.props.setFieldValue("isNotifyUser", checked);
            }}
            value={values.isNotifyUser}
            disabled={isDisabled}
          />
        }
      />
    );
  };

  handleAddressStateChange = (newVal) => {
    this.setState({...this.state, "state":newVal.value});
  }
  
  renderBrokerDashboardPreferenceInput = (values) => {
    if (!this.userBelongsToBrokerCompany()) {
      return null;
    }
    return (
      <FormControlLabel 
        label="Broker Dashboard Default View"
        labelPlacement="end"
        classes={{root: this.props.classes.checkboxLabelRoot}}
        control={
          <Checkbox
            name={"prefersBrokerDashboardView"}
            classes={{root: this.props.classes.checkboxRoot}}
            checked={values.user?.prefersBrokerDashboardView} 
            onChange={({ target: { checked  } }) => {
              this.props.setFieldValue("user.prefersBrokerDashboardView", checked );
            }}
            value={values.user?.prefersBrokerDashboardView}/>
          }
      />
    );
  };

  render() {
    if (!this.props.contactId || isEmpty(this.props.contact)) return null;

    const { values, companies, roles, authentication, errors } = this.props;

    if (!values) return null;
    
    const { isSystemAdmin } = authentication;
    
    return (
      <Fragment>
        <Modal
          hideModal={this.props.handleClose}
          open={this.props.isEditingContact}
          modalTitle="Edit User"
          className="editContact"
        >
          <DialogContent style={{ maxWidth: "800px" }}>
            <Grid container>
              <Grid item xs={6}>
                <FormControl
                  fullWidth
                  error={errors.firstNameError}
                  margin="normal"
                >
                  <InputLabel htmlFor="firstName">First Name</InputLabel>
                  <Input
                    type="text"
                    name="firstName"                    
                    value={values.firstName || ""}
                    onChange={({ target: { value } }) => {
                      this.props.setFieldValue("firstName", value);
                    }}
                  />
                  {errors.firstNameError ? (
                    <FormHelperText>First Name is Required</FormHelperText>
                  ) : null}
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl
                  fullWidth
                  error={errors.LastNameError}
                  margin="normal"
                >
                  <InputLabel htmlFor="lastName">Last Name</InputLabel>
                  <Input
                    type="text"
                    name="lastName"                    
                    value={values.lastName || ""}
                    onChange={({ target: { value } }) => {                      
                      this.props.setFieldValue("lastName", value);
                    }}
                  />

                  {errors.LastNameError ? (
                    <FormHelperText>Last Name is Required</FormHelperText>
                  ) : null}
                </FormControl>
              </Grid>

              {isSystemAdmin && (<Grid item xs={12}>
                <FormControl
                  fullWidth
                  error={errors.companyError}
                  margin="normal"
                >
                  <AutoCompleteInput 
                      label="Company"
                      fieldName="companyId"
                      options={companies}
                      selectName="name"
                      />
                  {errors.companyError && (
                    <FormHelperText>Company is Required</FormHelperText>
                  )}
                </FormControl>
              </Grid>)}
              <Grid item xs={12}>
                <FormControl
                  fullWidth
                  error={errors.emailError}
                  margin="normal">
                  <InputLabel htmlFor="email">Email</InputLabel>
                  <Input
                    type="text"
                    name="email"
                    value={values.email || ""}
                    onChange={({ target: { value } }) => {
                      this.props.setFieldValue("email", value);
                    }}
                    // Always true as of the deprecation
                    // of the red175NewLoginExperience flag
                    disabled={true}
                  />
                  {errors.emailError ? (
                    <FormHelperText>Email is Required</FormHelperText>
                  ) : null}
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth margin="normal">
                  <TextField
                    label="Phone"
                    type="text"
                    margin="normal"
                    name="phone"
                    value={values.phone || ""}
                    onChange={({ target: { value } }) => {
                      this.props.setFieldValue("phone", value);
                    }}
                    InputProps={{
                      inputComponent: inputComponentMask({
                        mask: "phone"
                      })
                    }}
                    style={{ marginLeft: 0 }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth margin="normal">
                  <InputLabel htmlFor="address">Address Line 1</InputLabel>
                  <Input
                    type="text"
                    name="address"
                    value={values.address || ""}
                    onChange={({ target: { value } }) => {
                      this.props.setFieldValue("address", value);
                    }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth margin="normal">
                  <InputLabel htmlFor="address2">Address Line 2</InputLabel>
                  <Input                    
                    type="text"
                    name="address2"
                    value={values.address2 || ""}
                    onChange={({ target: { value } }) => {
                      this.props.setFieldValue("address2", value);
                    }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={4}>
                <FormControl fullWidth error={errors.cityError} margin="normal">
                  <InputLabel htmlFor="city">City</InputLabel>
                  <Input
                    type="text"
                    name="city"
                    value={values.city || ""}
                    onChange={({ target: { value } }) => {
                      this.props.setFieldValue("city", value);
                    }}
                  />
                  {errors.cityError ? (
                    <FormHelperText>City is Required</FormHelperText>
                  ) : null}
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl
                  fullWidth
                  error={errors.stateError}
                  margin="normal"
                >
                  <InputLabel htmlFor="state">State</InputLabel>

                  <AutoCompleteInput              
                    name="state"
                    selectName='name'
                    selectValue='value'
                    fieldName="state"
                    onChange={(newVal) => {
                      this.props.setFieldValue("state",newVal.value,false);
                    }}
                    options={states}/>

                  {errors.stateError ? (
                    <FormHelperText>State is Required</FormHelperText>
                  ) : null}
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth error={errors.zipError} margin="normal">
                  <InputLabel htmlFor="zip">Zip Code</InputLabel>
                  <Input
                    type="text"
                    name="zip"
                    value={values.zip || ""}
                    onChange={({ target: { value } }) => {
                      this.props.setFieldValue("zip", value);
                    }}
                  />
                  {errors.zipError ? (
                    <FormHelperText>Zip Code is Required</FormHelperText>
                  ) : null}
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <FormControl fullWidth error={errors.roleError} margin="normal">                
                  <InputLabel htmlFor="role">Role</InputLabel>
                  <Select
                    name="role"
                    value={_.get(values, 'user.roles[0].role', '')}
                    onChange={event => {
                      this.addUpdateRole(event.target.value);
                    }}
                    inputProps={{ name: `role` }} >
                    {roles &&
                      roles.map(item => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.displayName}
                        </MenuItem>
                      ))}
                  </Select>
                  {errors.roleError ? (
                    <FormHelperText>Role is Required</FormHelperText>
                  ) : null}
                </FormControl>
              </Grid>
              {isSystemAdmin && (
                <Grid item xs={6}>
                  <Grid container>
                    {!this.props.values.isPasswordSet && (
                      <Grid item xs={5}>
                        {this.renderNotifyUserCheckbox()}
                      </Grid>
                    )}
                    <Grid item xs={7}>
                      {this.renderReportDesignerButton()}
                    </Grid>
                    <Grid item>
                      {this.renderBrokerDashboardPreferenceInput(values)}
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              disabled={errors.pageError}
              onClick={this.handleSubmit}
              type="submit"
            >
              Save
            </Button>
            <Button onClick={this.props.handleClose}>Cancel</Button>
          </DialogActions>
        
        </Modal>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  loading,
  authentication,
  contacts,
  companies,
  roles
}) => ({
  loading,
  authentication,
  contacts: contacts.contacts,
  contact: contacts.contact,
  companies: companies.allCompanies ? companies.allCompanies.companies : [],
  roles,
  companyTypes: companies.companyTypesById ?? []
});

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    { getContact, getContacts, updateContact, fetchRoles, getCompanyTypeById }
  ),
  withFormik({
    mapPropsToValues: props => (props.contact ? props.contact.contact : ""),
    enableReinitialize: true,
    validate: (values,{ ...actions }) => {
      const errors = {
        firstNameError: false,
        lastNameError: false,
        companyError: false,
        emailError: false,
        addressError: false,
        cityError: false,
        stateError: false,
        zipError: false,
        pageError: false,
        roleError: false
      };

      const isCompanyAdmin = actions && actions.authentication && actions.authentication.isCompanyAdmin;
      const role = values.user && values.user.roles.length > 0 && values.user.roles[0].role ? values.user.roles[0].role : null;

      errors.roleError = isCompanyAdmin && isEmpty(role)
      errors.firstNameError = isEmpty(values.firstName);
      errors.lastNameError = isEmpty(values.lastName);
      errors.companyError = values.companyId === null;
      errors.emailError = isEmpty(values.email);

      errors.pageError =
        errors.firstNameError ||
        errors.lastNameError ||
        errors.companyError ||
        errors.emailError ||
        errors.addressError ||
        errors.cityError ||
        errors.stateError ||
        errors.zipError||
        errors.roleError;

      return errors;
    },
    displayName: "UpdateContact"
  })
)(ContactEdit);
